<template>
  <div style="display: flex; align-items: center;">
    <v-menu
      ref="beginPicker"
      v-model="showBeginPicker"
      :close-on-content-click="false"
      nudge-bottom="1"
      offset-y
      transition="scale-transition"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          class="mr-1 ml-1"
          rounded
          v-on="on"
        >
          {{ begin | toLocaleDate($i18n.locale) }}
        </v-btn>
      </template>
      <v-date-picker
        ref="picker"
        v-model="begin"
        :locale="$i18n.locale"
        :min="dateMin"
        :max="end"
        :show-current="dateNow"
        color="primary"
        type="month"
        prev-icon="fas fa-angle-left"
        next-icon="fas fa-angle-right"
      />
    </v-menu>
    <v-icon
      color="primary"
      small
    >
      fas fa-arrow-right
    </v-icon>
    <v-menu
      ref="endPicker"
      v-model="showEndPicker"
      :close-on-content-click="false"
      nudge-bottom="1"
      offset-y
      transition="scale-transition"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          class="mr-1 ml-1"
          rounded
          v-on="on"
        >
          {{ end | toLocaleDate($i18n.locale) }}
        </v-btn>
      </template>
      <v-date-picker
        ref="picker"
        v-model="end"
        :locale="$i18n.locale"
        :min="begin"
        :max="dateNow"
        :show-current="dateNow"
        color="primary"
        type="month"
        prev-icon="fas fa-angle-left"
        next-icon="fas fa-angle-right"
      />
    </v-menu>
  </div>
</template>
<script>
  import Utils from '../../plugins/utils'

  export default {
    name: 'Daterangepicker',
    filters: {
      toLocaleDate (value, locale) {
        const options = { year: 'numeric', month: 'long' }
        const date = new Date(value)
        return date.toLocaleDateString(locale, options)
      },
    },
    data () {
      return {
        showBeginPicker: false,
        dateNow: null,
        dateMin: null,
        showEndPicker: false,
      }
    },
    computed: {
      begin: {
        get () {
          return this.$store.state.date.begin.substr(0, 7)
        },
        set (value) {
          this.$refs.beginPicker.save()
          this.$store.dispatch('setBegin', Utils.formatDate(value))
        },
      },
      end: {
        get () {
          return this.$store.state.date.end.substr(0, 7)
        },
        set (value) {
          this.$refs.endPicker.save()
          this.$store.dispatch('setEnd', Utils.formatDate(value, true))
        },
      },
    },
    mounted () {
      const now = new Date()
      this.dateNow = now.getFullYear() + '-' + (now.getMonth() + 1)
      this.dateMin = now.getFullYear() - 3 + '-' + (now.getMonth() + 1)
    },
  }
</script>
